import ProcedureFilterBar from '../ProcedureFilterBar';
import ProcedureList from '../ProcedureList';

import ProcedureHeader from './ProcedureHeader';
import ProcedureLayout from './ProcedureLayout';
import useProcedureReport from './hooks';

const ProcedurePage = () => {
  const { procedureReports, isLoading } = useProcedureReport();

  return (
    <ProcedureLayout>
      <div>
        <ProcedureHeader />
        <ProcedureFilterBar />
      </div>
      <ProcedureList procedureReports={procedureReports} loading={isLoading} />
    </ProcedureLayout>
  );
};

export default ProcedurePage;
